import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPatientDataModel } from 'src/app/model/common/patient-data';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { CommonTurnViewModel } from 'src/app/model/common/turn.view';
import { GENERAL_CONSULT_CONSTANTS } from './consult.constants';
import { GeneralConsultService } from './consult.service';

@Component({
  selector: 'ms-general-consult',
  templateUrl: './consult.component.html',
})
export class GeneralConsultComponent extends BaseComponent {
  readonly screen = GENERAL_CONSULT_CONSTANTS;
  turnId?: number;
  patientId?: number;
  turn: CommonTurnViewModel = {} as CommonTurnViewModel;
  patient: CommonPatientViewModel = {};
  patientData: CommonPatientDataModel = {};
  oldTurns: CommonTurnViewModel[] = [];
  isFinal = false;
  consultSaved = false;
  historySaved = false;
  turnStatusConsult?: string;
  turnStatusFinish?: string;
  isGyne = false;
  saving = false;
  finalSaving = false;
  isEdit = false;
  isSticky = false;

  constructor(
    protected route: ActivatedRoute,
    protected service: GeneralConsultService
  ) {
    super();
  }

  onInit = () => {
    this.service.setScreenInformation({
      id: this.screen.id,
      title: this.screen.title,
      showHeading: false,
    });
    this.subscriptions.push(
      this.service
        .getSavingState()
        .subscribe((saving) => (this.saving = saving)),
      this.service.savedConsult().subscribe((save) => {
        this.consultSaved = save;
        this.finalSave();
      }),
      this.service.savedHistory().subscribe((save) => {
        this.historySaved = save;
        this.finalSave();
      }),
      this.route.queryParams
        .pipe(
          tap((params) => {
            this.turnId = params.turn;
            this.isEdit = params.isEdit;
            this.service.getTurn(params.turn).subscribe((turn) => {
              this.turn = turn;
              this.patientId = turn.patient;
              this.turn.turnDate = new Date(this.turn.turnDate!);
              this.isGyne = this.turn.specialtyCodeAlt === 'GYNE';

              this.subscriptions.push(
                this.service
                  .getPatient(this.turn.patient!)
                  .subscribe((patient) => (this.patient = patient)),
                this.service.loadPatient(this.turn.patient!).subscribe(),
                this.service.loadPerson(this.turn.person!).subscribe(),
                this.service.readTurnStatusStore().subscribe((turnStatus) => {
                  if (turnStatus.length > 0) {
                    const consult = turnStatus.find(
                      (status) => status.codeAlt === 'in-progress'
                    )!;
                    this.turnStatusConsult = consult.id;
                    const finish = turnStatus.find(
                      (status) => status.codeAlt === 'finish'
                    )!;
                    this.turnStatusFinish = finish.id;

                    if (
                      this.turn.turnStatusCodeAlt?.toLowerCase() === 'waiting'
                    ) {
                      this.service
                        .moveTurnStatus(this.turn.id!, this.turnStatusConsult!)
                        .subscribe();
                    }
                  }
                }),
                this.service
                  .getParametrizationBySpecialtyAndPatient(
                    this.turn.specialty!,
                    this.turn.patient!
                  )
                  .subscribe()
              );

              if (!this.isEdit) {
                this.subscriptions.push(
                  this.service
                    .getOldTurns(this.turn.patient!, this.turn.id!)
                    .subscribe((turns) => (this.oldTurns = turns))
                );
              }
            });
          })
        )
        .subscribe()
    );
  };

  openPatientDialog = () => {
    this.service.openPatientDialog().onClose.subscribe((modalResult) => {
      if (modalResult) {
        this.patient = modalResult;
        this.subscriptions.push(
          this.service.loadPatient(this.turn.patient!).subscribe(),
          this.service.loadPerson(this.turn.person!).subscribe()
        );
      }
    });
  };

  save = ($event: { draft: boolean; isReport?: boolean }) => {
    this.saving = true;
    this.isFinal = !$event.draft;
    this.service.save();
    if ($event.isReport) {
      this.generateMedicalHistory();
    }
  };

  finalSave = () => {
    if (this.consultSaved && this.historySaved) {
      this.finalSaving = true;
      this.subscriptions.push(
        this.service
          .finalSave(this.isFinal, this.turn.id!, this.turnStatusFinish!)
          .subscribe(
            () => (this.finalSaving = false),
            () => (this.finalSaving = false)
          )
      );
    }
  };

  generateMedicalHistory = () => {
    this.service.setLoadingState();
    this.service
      .generateCertificate(this.patient.clinicHistory!, this.turn.id!)
      .subscribe();
  };
}
